module.exports = __webpack_public_path__ + "img/6-5.cc8cf6ae.png";